import { render, staticRenderFns } from "./ResumePurchaser.vue?vue&type=template&id=4f598412"
import script from "./ResumePurchaser.vue?vue&type=script&lang=js"
export * from "./ResumePurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports